import Vue from 'vue'
import Router from 'vue-router'
import routers from './routers'
import storage from 'store'
import { isWeixin} from '@/libs/utils'
Vue.use(Router);

const router = new Router({
  mode:'history',
  routes: routers
});
router.beforeEach((to, from, next) => {
  // if (to.meta.hasOwnProperty('token')) {
  //   if (isWeixin()) {
  //     if (!storage.get('token')) {
  //       if (to.path==='/auth') {
  //         next()
  //       } else {
  //         storage.set('nowUrl', to.fullPath)//当前页url与参数放入缓存
  //         next('/auth')
  //       }
  //     } else {
  //       next();
  //     }
  //   } else if(storage.get('token')){
  //     next();
  //   } else {
  //     next('/user/login')
  //   }
  // } else {
  //   next()
  // }
  next()
})

router.afterEach(to => {
  window.scrollTo(0, 0)
})

export default router
